import React from 'react';
import AsyncPage from './async';
import DefaultConsumerLayout from '../../../../components/layout/DefaultConsumerLayout';

export default [
  <DefaultConsumerLayout
    key="/consumer/features/ai-video-enhance"
    exact
    path="/consumer/features/ai-video-enhance"
    component={AsyncPage}
  />,
];
